export const blockIconsUiactionsCheckCircleNew = (
	<span className='material-symbols-outlined'>check_circle</span>
);
